import { Button, TopToolbar } from "react-admin";
import MenuIcon from '@mui/icons-material/Menu';

function goBackOne () {
    window.history.go(-1)
}

export function IndietroButton () {
    return  (
        <Button label="Torna indietro" onClick={goBackOne}  icon={<MenuIcon />}/>
    )
}
export const ItasEditActions = () => (
    
    <TopToolbar>
        {/* Add your custom actions */}
        <IndietroButton />
    </TopToolbar>
  );